export const FONT_OPTIONS = [
  { id: 'inter', name: 'Clean Sans', family: 'Inter', url: null },
  { id: 'poppins', name: 'Poppins', family: 'Poppins', url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap' },
  { id: 'bebas', name: 'Bold Display', family: 'Bebas Neue', url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap' },
  { id: 'oswald', name: 'Oswald', family: 'Oswald', url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&display=swap' },
  { id: 'caveat', name: 'Handwritten', family: 'Caveat', url: 'https://fonts.googleapis.com/css2?family=Caveat:wght@400;600;700&display=swap' },
  { id: 'dancing', name: 'Script', family: 'Dancing Script', url: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;600;700&display=swap' },
  { id: 'spacemono', name: 'Mono', family: 'Space Mono', url: 'https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap' },
  { id: 'pressstart', name: 'Retro Pixel', family: 'Press Start 2P', url: 'https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap' },
  { id: 'playfair', name: 'Elegant Serif', family: 'Playfair Display', url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap' },
  { id: 'cormorant', name: 'Classic Serif', family: 'Cormorant Garamond', url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&display=swap' },
  { id: 'rajdhani', name: 'Tech', family: 'Rajdhani', url: 'https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;600;700&display=swap' },
  { id: 'righteous', name: 'Groovy', family: 'Righteous', url: 'https://fonts.googleapis.com/css2?family=Righteous&display=swap' },
];

export const ANIMATION_OPTIONS = [
  { id: 'none', name: 'None', description: 'No animation' },
  { id: 'fade', name: 'Fade In', description: 'Smooth fade' },
  { id: 'slide-up', name: 'Slide Up', description: 'Slides from bottom' },
  { id: 'scale', name: 'Scale', description: 'Bouncy zoom in' },
  { id: 'typewriter', name: 'Typewriter', description: 'Letter by letter' },
  { id: 'stagger', name: 'Stagger', description: 'Elements appear one by one' },
];

export const BUTTON_STYLE_OPTIONS = [
  { id: 'rounded', name: 'Rounded', borderRadius: '1rem', border: true },
  { id: 'pill', name: 'Pill', borderRadius: '9999px', border: true },
  { id: 'square', name: 'Square', borderRadius: '0.25rem', border: true },
  { id: 'sharp', name: 'Sharp', borderRadius: '0', border: true },
  { id: 'outline-round', name: 'Outline Round', borderRadius: '1rem', border: true, outline: true },
  { id: 'ghost', name: 'Ghost', borderRadius: '1rem', border: false },
];

export const LAYOUT_OPTIONS = [
  { id: 'centered', name: 'Centered', description: 'Everything centered' },
  { id: 'left', name: 'Left Aligned', description: 'Content aligned left' },
];

// ---- v2 customisation (Feb 2026) ----
// Avatar shapes — Round (free), Squircle (Pro rounded-square), Full-width
// square (Pro, full-bleed at top of profile with theme feather at bottom).
// Hexagon and Heart shapes were removed Feb 2026.
export const AVATAR_SHAPES = [
  { id: 'round', name: 'Round', clipPath: null, borderRadius: '9999px' },
  { id: 'squircle', name: 'Squircle', pro: true, clipPath: null, borderRadius: '32%' },
  { id: 'full_square', name: 'Full-width square', pro: true, fullWidth: true, clipPath: null, borderRadius: '0' },
];

export const LINK_CARD_STYLES = [
  { id: 'classic', name: 'Classic', description: 'Solid card' },
  { id: 'glass', name: 'Glass', pro: true, description: 'Frosted glass with blur' },
  { id: 'stacked', name: 'Stacked', pro: true, description: 'Layered card with depth' },
];

export const BG_EFFECTS = [
  { id: 'none', name: 'None', description: 'Plain background' },
  { id: 'grain', name: 'Live Grain', pro: true, description: 'Animated film grain' },
  { id: 'starfield', name: 'Starfield', pro: true, description: 'Subtle drifting stars' },
  { id: 'spotlight', name: 'Spotlight', pro: true, description: 'Follows cursor' },
];

export const ORBIT_SPEEDS = [
  { id: 'slow', name: 'Slow', seconds: 70 },
  { id: 'normal', name: 'Normal', seconds: 45 },
  { id: 'fast', name: 'Fast', seconds: 25 },
];

export const ORBIT_DIRECTIONS = [
  { id: 'cw', name: 'Clockwise' },
  { id: 'ccw', name: 'Counter-clockwise' },
];

export const getAvatarShape = (id) => AVATAR_SHAPES.find(s => s.id === id) || AVATAR_SHAPES[0];
export const getLinkCardStyle = (id) => LINK_CARD_STYLES.find(s => s.id === id) || LINK_CARD_STYLES[0];
export const getBgEffect = (id) => BG_EFFECTS.find(e => e.id === id) || BG_EFFECTS[0];
export const getOrbitSpeed = (id) => ORBIT_SPEEDS.find(s => s.id === id) || ORBIT_SPEEDS[1];

export const getFontById = (id) => FONT_OPTIONS.find(f => f.id === id) || FONT_OPTIONS[0];

export const ALL_FONTS_URL = 'https://fonts.googleapis.com/css2?family=' + 
  FONT_OPTIONS.filter(f => f.url).map(f => f.family.replace(/ /g, '+')).join('&family=') + 
  '&display=swap';

export const getAnimationCSS = (animId, index = 0) => {
  const delay = index * 0.08;
  switch (animId) {
    case 'fade':
      return { animation: `fadeIn 0.6s ease-out ${delay}s both` };
    case 'slide-up':
      return { animation: `slideUp 0.5s ease-out ${delay}s both` };
    case 'scale':
      return { animation: `scaleIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) ${delay}s both` };
    case 'stagger':
      return { animation: `fadeIn 0.4s ease-out ${delay}s both` };
    default:
      return {};
  }
};

export const ANIMATION_KEYFRAMES = `
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.85); }
  to { opacity: 1; transform: scale(1); }
}
`;
